import { defineComponent, onBeforeMount } from 'vue';
import NavigationBar from '@/presentation/components/shared/navigation-bar/navigation-bar.vue';
import ErrorMessage from '@/presentation/components/shared/error-message/error-message.vue';
import AppCode from '@/presentation/app.code';

export default defineComponent({
	components: {
		NavigationBar,
		ErrorMessage
	},
	setup: () => {
		const code = new AppCode();

		onBeforeMount(code.mounted.bind(code));

		return {
			CurrentComponent: code.CurrentComponent,
			errorMessage: code.errorMessage
		};
	}
});
